module.exports = __webpack_public_path__ + "img/vertical_7_1_7042.5ddfd469.png";